<template>
  <div id="app">
    <toolbar></toolbar>
    <router-view/>
    <the-footer></the-footer>
  </div>
</template>

<script>
import Toolbar from './components/Toolbar'
import TheFooter from './components/TheFooter'

export default {
  name: 'app',

  components: {Toolbar, TheFooter}
}
</script>

<style>
/* * {
  box-sizing: border-box;
} */
#app {
  font-family: 'Open sans', sans-serif;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
.file-picker .file-icon {
  display: none;
}

.file.is-boxed .file-cta {
  padding: 1em 0 !important;
}
</style>
